window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.form-has-file').length) {
    import('./_fileupload.js').then((module) => {
      module.Init();
    });
  }
});

export default {}
